export { default } from './money-input'
export type { TProps as MoneyInputProps } from './money-input'
